<app-traitement-data titre="EPAP 95" [sousTitre]="patient!.tableauDeBord?.epap95?.date | aLaDateDu"
    [statut]="patient!.tableauDeBord?.epap95?.value ? 'info' : 'warning'">
    {{ patient!.tableauDeBord?.epap95?.value ?? 'Pas de donnée' }}
</app-traitement-data>